import { BlokProps } from "@helpers/StoryblokHelpers"
import { HeroSectionStoryblok } from "@storyblok-types"
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc"
import Image from "next/image"

export const HeroSection = ({ blok }: BlokProps<HeroSectionStoryblok>) => {
  const {
    title,
    subtitle,
    hero_image_large,
    hero_image_small,
    partner_logo,
    use_hero_image,
    use_branding,
    branding_subtitle,
    branding_image
  } = blok

  return (
    <section
      className="flex flex-col gap-6 bg-surface py-[18px] lg:gap-8 lg:py-10"
      {...storyblokEditable(blok as SbBlokData)}
    >
      {use_hero_image && (
        <div className="relative mx-auto w-full xl:px-8">
          {hero_image_small?.filename && (
            <Image
              src={hero_image_small.filename}
              alt={hero_image_small?.alt || ""}
              width={768}
              height={0}
              loading="eager"
              sizes="100vw"
              className="h-auto w-full md:hidden"
            />
          )}

          {hero_image_large?.filename && (
            <Image
              src={hero_image_large.filename}
              alt={hero_image_large?.alt || ""}
              width={1155}
              height={0}
              loading="eager"
              sizes="(max-width: 1155px) 100vw, 1155px"
              className="hidden h-auto w-full md:block"
            />
          )}

          {partner_logo?.filename && (
            <div className="absolute bottom-5 left-9 z-30 sm:bottom-8 sm:left-12 lg:bottom-10 lg:left-[72px]">
              <Image
                src={partner_logo.filename}
                alt={partner_logo?.alt || ""}
                width={193}
                height={60}
                sizes="193px"
                className="h-[34px] w-auto sm:h-[40px] lg:h-[48px]"
              />
            </div>
          )}
        </div>
      )}

      <div className="mx-auto w-full max-w-[1155px] px-4 pb-0 pt-8 text-left lg:px-8 xl:pt-10">
        <h1 className="text-[32px] font-bold leading-[1.04] tracking-[-0.065em] text-neutral-90 sm:text-[48px] md:text-[56px] lg:text-[64px]">
          {title}
        </h1>
        {/* `use_branding` is the switch — off means no branding at all. With it on, the image wins
            and the subtitle is the fallback for stories that have no asset uploaded. */}
        {use_branding &&
          (branding_image?.filename ? (
            <Image
              src={branding_image.filename}
              alt={branding_image?.alt || ""}
              // Matches the lockup's own 577x50 artboard. These only reserve space before the file
              // loads — CSS sizes it — but a wrong ratio makes the box reflow once it arrives.
              width={577}
              height={50}
              loading="eager"
              unoptimized
              className="mt-3 h-5 w-auto sm:h-6 lg:h-7"
            />
          ) : (
            <p className="mt-3 text-[15px] font-normal leading-[22px] tracking-normal text-neutral-50 lg:text-[16px]">
              {branding_subtitle}
            </p>
          ))}

        <p className="mt-4 text-[15px] font-normal leading-[22px] tracking-normal text-neutral-50 lg:text-[16px]">
          {subtitle}
        </p>
      </div>
    </section>
  )
}
